const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export const emptySectionForm = {
  nom_section: "",
  discipline_section: "",
  slug: "",
  category_id: "",
  is_active: true,
  is_featured: false,
  ordre: 999,
  logo_section: "",
  photoURL: "",
  responsable_section: "",
  tel_section: "",
  mail_section: "",
  siteweb_section: "",
  adresse_section: "",
  facebook_section: "",
  instagram_section: "",
  lien_section: "",
  header1_URL: "",
  header2_URL: "",
  about_content: "",
  carrousel_id: "",
};

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.sections)) return data.sections;
    if (Array.isArray(data.data)) return data.data;
  }

  return [];
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function slugify(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function isExternalURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = "/images/asso_placeholder.jpg") {
  if (!url) return fallback;

  const value = String(url).trim();

  if (
    isExternalURL(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${API_BASE}${value}`;
  }

  return value;
}

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function getCategoryLabel(section, categoriesById) {
  if (!section?.category_id) return "Non catégorisée";
  return categoriesById[String(section.category_id)]?.label || "Non catégorisée";
}

export function getSectionStatus(section) {
  if (section?.is_active === false) {
    return {
      label: "Inactive",
      className:
        "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
    };
  }

  return {
    label: "Active",
    className:
      "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
  };
}

export function getStats(sections) {
  return {
    total: sections.length,
    active: sections.filter((section) => section.is_active !== false).length,
    inactive: sections.filter((section) => section.is_active === false).length,
    featured: sections.filter((section) => section.is_featured === true).length,
  };
}

export function mapSectionToForm(section = {}) {
  return {
    nom_section: section.nom_section || "",
    discipline_section: section.discipline_section || "",
    slug: section.slug || "",
    category_id: section.category_id || "",
    is_active:
      typeof section.is_active === "boolean" ? section.is_active : true,
    is_featured:
      typeof section.is_featured === "boolean" ? section.is_featured : false,
    ordre: section.ordre ?? 999,
    logo_section: section.logo_section || "",
    photoURL: section.photoURL || "",
    responsable_section: section.responsable_section || "",
    tel_section: section.tel_section || "",
    mail_section: section.mail_section || "",
    siteweb_section: section.siteweb_section || "",
    adresse_section: section.adresse_section || "",
    facebook_section: section.facebook_section || "",
    instagram_section: section.instagram_section || "",
    lien_section: section.lien_section || "",
    header1_URL: section.header1_URL || "",
    header2_URL: section.header2_URL || "",
    about_content: section.about_content || "",
    carrousel_id: section.carrousel_id || "",
  };
}

export function buildSectionPayload(formData) {
  return {
    nom_section: formData.nom_section,
    discipline_section: formData.discipline_section,
    slug:
      formData.slug ||
      (formData.nom_section
        ? `/associations/${slugify(formData.nom_section)}`
        : ""),
    category_id: formData.category_id ? Number(formData.category_id) : null,
    is_active: Boolean(formData.is_active),
    is_featured: Boolean(formData.is_featured),
    ordre: Number(formData.ordre || 999),
    logo_section: formData.logo_section,
    photoURL: formData.photoURL,
    responsable_section: formData.responsable_section,
    tel_section: formData.tel_section,
    mail_section: formData.mail_section,
    siteweb_section: formData.siteweb_section,
    adresse_section: formData.adresse_section,
    facebook_section: formData.facebook_section,
    instagram_section: formData.instagram_section,
    lien_section: formData.lien_section,
    header1_URL: formData.header1_URL,
    header2_URL: formData.header2_URL,
    about_content: formData.about_content,
    carrousel_id: formData.carrousel_id ? Number(formData.carrousel_id) : null,
  };
}